<textarea name="dentist-internal-note" id="dentist-internal-note" class="internal-note-textarea"
    placeholder="Add a note" (keydown.enter)="onNewInternalNoteSubmit($event)"
    [(ngModel)]="newInternalNote"></textarea>
<div class="note-container d-flex mb-1" *ngFor="let internalNote of internalNotes.slice().reverse()"
    nbTooltip="{{internalNote.createdAt | date : 'dd/M/yy hh:mm a'}} {{internalNote.creatorFullName}}"
    nbTooltipStatus="control">
    <textarea name="dentist-internal-note" id="dentist-internal-note" class="internal-note-textarea"
        placeholder="Add a note" (keydown.enter)="onInternalNoteUpdateSubmit($event, internalNote)"
        [(ngModel)]="internalNote.contents" [disabled]="internalNote.createdById !== userId"></textarea>
</div>